var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGod(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.875,
    height: 23.875,
    viewBox: "0 0 23.875 23.875",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "God",
    transform: "translate(-2 -0.051)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_5",
    "data-name": "Raggruppa 5",
    transform: "translate(2 0.051)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_22",
    "data-name": "Tracciato 22",
    d: "M10.912,23.538l.363.364-1.71,1.714a2.308,2.308,0,0,0-3.109.156,2.329,2.329,0,1,0,3.5.26l1.736-1.74.363.364,1.166-2.285Zm11.194-5.686a4.126,4.126,0,0,0-4.275-3.973,4.143,4.143,0,0,0-4.275,3.973,4.126,4.126,0,0,0,4.275,3.973,4.126,4.126,0,0,0,4.275-3.973m.6,0a4.784,4.784,0,0,1-4.871,4.7,4.807,4.807,0,0,1-4.9-4.7,4.786,4.786,0,0,1,4.9-4.674A4.78,4.78,0,0,1,22.7,17.851m1.036,0a5.82,5.82,0,0,0-5.908-5.712A5.843,5.843,0,0,0,11.9,17.851a5.924,5.924,0,0,0,11.842,0M28.973,6.557a2.322,2.322,0,0,0-3.5,3.038l-1.736,1.74-.363-.364L22.21,13.255l2.28-1.168-.363-.364,1.71-1.714a2.336,2.336,0,0,0,3.135-3.453",
    transform: "translate(-5.775 -5.875)",
    fill: "#c9d3f2"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGod);
export default __webpack_public_path__ + "static/media/God.d2de5b93b503b67a04a06601efbcdbb5.svg";
export { ForwardRef as ReactComponent };